import React from "react";

const DeepIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
            <path
                d="M31.2618 11.1797L18.6444 7.79891C17.6941 7.5443 16.7174 8.10821 16.4628 9.05845L11.8526 26.264C11.598 27.2142 12.1619 28.191 13.1121 28.4456L25.7295 31.8264C26.6798 32.081 27.6565 31.5171 27.9111 30.5669L32.5213 13.3613C32.7759 12.4111 32.212 11.4344 31.2618 11.1797Z"
                fill="white"
                stroke="#CBD5E1"
            />
            <path d="M19.4434 11.7012L28.6197 14.16" stroke="#CBD5E1" strokeLinecap="round" />
            <path d="M18.5215 15.1426L27.6978 17.6014" stroke="#CBD5E1" strokeLinecap="round" />
            <path d="M17.5996 18.584L24.4818 20.4281" stroke="#CBD5E1" strokeLinecap="round" />
            <path d="M16.6777 22.0234L25.854 24.4822" stroke="#CBD5E1" strokeLinecap="round" />
            <path d="M15.7539 25.4648L21.4891 27.0016" stroke="#CBD5E1" strokeLinecap="round" />
            <path
                d="M19.8125 11.5H10.3125C9.00082 11.5 7.9375 12.5633 7.9375 13.875V23.375C7.9375 24.6867 9.00082 25.75 10.3125 25.75H19.8125C21.1242 25.75 22.1875 24.6867 22.1875 23.375V13.875C22.1875 12.5633 21.1242 11.5 19.8125 11.5Z"
                fill="url(#paint0_linear_2867_128161)"
            />
            <path
                d="M16.8438 8.53125H13.2812C12.6254 8.53125 12.0938 9.06291 12.0938 9.71875C12.0938 10.3746 12.6254 10.9062 13.2812 10.9062H16.8438C17.4996 10.9062 18.0312 10.3746 18.0312 9.71875C18.0312 9.06291 17.4996 8.53125 16.8438 8.53125Z"
                fill="url(#paint1_linear_2867_128161)"
            />
            <path
                d="M15.0625 10.3125C15.7183 10.3125 16.25 9.78084 16.25 9.125C16.25 8.46916 15.7183 7.9375 15.0625 7.9375C14.4067 7.9375 13.875 8.46916 13.875 9.125C13.875 9.78084 14.4067 10.3125 15.0625 10.3125Z"
                fill="url(#paint2_linear_2867_128161)"
            />
            <path
                d="M12.0938 18.0312C13.0775 18.0312 13.875 17.2338 13.875 16.25C13.875 15.2662 13.0775 14.4688 12.0938 14.4688C11.11 14.4688 10.3125 15.2662 10.3125 16.25C10.3125 17.2338 11.11 18.0312 12.0938 18.0312Z"
                fill="white"
            />
            <path
                d="M18.0312 18.0312C19.015 18.0312 19.8125 17.2338 19.8125 16.25C19.8125 15.2662 19.015 14.4688 18.0312 14.4688C17.0475 14.4688 16.25 15.2662 16.25 16.25C16.25 17.2338 17.0475 18.0312 18.0312 18.0312Z"
                fill="white"
            />
            <path
                d="M12.0945 17.2008C12.6192 17.2008 13.0445 16.7755 13.0445 16.2508C13.0445 15.7261 12.6192 15.3008 12.0945 15.3008C11.5699 15.3008 11.1445 15.7261 11.1445 16.2508C11.1445 16.7755 11.5699 17.2008 12.0945 17.2008Z"
                fill="#1E293B"
            />
            <path
                d="M18.032 17.2008C18.5567 17.2008 18.982 16.7755 18.982 16.2508C18.982 15.7261 18.5567 15.3008 18.032 15.3008C17.5074 15.3008 17.082 15.7261 17.082 16.2508C17.082 16.7755 17.5074 17.2008 18.032 17.2008Z"
                fill="#1E293B"
            />
            <path d="M13.2812 21L13.875 22.1875H16.25L16.8438 21" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M7.34375 17.4375H6.75C6.42208 17.4375 6.15625 17.7033 6.15625 18.0312V20.4062C6.15625 20.7342 6.42208 21 6.75 21H7.34375C7.67167 21 7.9375 20.7342 7.9375 20.4062V18.0312C7.9375 17.7033 7.67167 17.4375 7.34375 17.4375Z"
                fill="url(#paint3_linear_2867_128161)"
            />
            <path
                d="M23.375 17.4375H22.7812C22.4533 17.4375 22.1875 17.7033 22.1875 18.0312V20.4062C22.1875 20.7342 22.4533 21 22.7812 21H23.375C23.7029 21 23.9688 20.7342 23.9688 20.4062V18.0312C23.9688 17.7033 23.7029 17.4375 23.375 17.4375Z"
                fill="url(#paint4_linear_2867_128161)"
            />
            <path
                d="M11.5 25.75V28.125L12.6875 29.3125H10.3125"
                stroke="url(#paint5_linear_2867_128161)"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18.625 25.75V28.125L19.8125 29.3125H17.4375"
                stroke="url(#paint6_linear_2867_128161)"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_2867_128161"
                    x1="7.9375"
                    y1="11.5"
                    x2="22.1875"
                    y2="25.75"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#8B5CF6" />
                    <stop offset="1" stopColor="#3B82F6" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_2867_128161"
                    x1="12.0938"
                    y1="8.53125"
                    x2="13.7317"
                    y2="12.6261"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#8B5CF6" />
                    <stop offset="1" stopColor="#3B82F6" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_2867_128161"
                    x1="13.875"
                    y1="7.9375"
                    x2="16.25"
                    y2="10.3125"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#8B5CF6" />
                    <stop offset="1" stopColor="#3B82F6" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_2867_128161"
                    x1="6.15625"
                    y1="17.4375"
                    x2="9.00625"
                    y2="18.8625"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#8B5CF6" />
                    <stop offset="1" stopColor="#3B82F6" />
                </linearGradient>
                <linearGradient
                    id="paint4_linear_2867_128161"
                    x1="22.1875"
                    y1="17.4375"
                    x2="25.0375"
                    y2="18.8625"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#8B5CF6" />
                    <stop offset="1" stopColor="#3B82F6" />
                </linearGradient>
                <linearGradient
                    id="paint5_linear_2867_128161"
                    x1="10.3125"
                    y1="25.75"
                    x2="13.601"
                    y2="27.9423"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#8B5CF6" />
                    <stop offset="1" stopColor="#3B82F6" />
                </linearGradient>
                <linearGradient
                    id="paint6_linear_2867_128161"
                    x1="17.4375"
                    y1="25.75"
                    x2="20.726"
                    y2="27.9423"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#8B5CF6" />
                    <stop offset="1" stopColor="#3B82F6" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default DeepIcon;
